import {
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import React from "react";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";

import lamactPic from "./LogoW.png";
import styles from "./styles.module.css";

export default function ResponsiveFooter() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // SNSアイコン
  const TikTokIcon = ({ color = "#dddddd" }) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={24}
      height={24}
    >
      <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
    </svg>
  );

  const externalLinks = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const SOCIAL_LINKS = [
    {
      icon: <YouTubeIcon />,
      url: "https://www.youtube.com/channel/UCuzKLh0FAXizLRHkx2Rk4kw",
    },
    { icon: <InstagramIcon />, url: "https://www.instagram.com/lamact_t" },
    { icon: <TikTokIcon />, url: "https://www.tiktok.com/@lamact_2" },
    { icon: <TwitterIcon />, url: "https://twitter.com/LamactT" },
  ];

  return (
    <Box component="footer" className={styles.footer} sx={{ px: 2, py: 8 }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <div
          onClick={() => {
            window.open("https://lamact.com/");
          }}
          style={{
            color: "#000000",
            width: "170px",
            height: "48px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: `url(${lamactPic})`,
            backgroundSize: "170px 48px",
            cursor: "pointer",
          }}
        ></div>
      </div>
      {/* <br /> */}

      <Typography
        component="div"
        variant="body2"
        align="center"
        style={{ color: "#dddddd" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          {SOCIAL_LINKS.map(({ icon, url }) => (
            <IconButton
              color="inherit"
              key={url}
              onClick={() => externalLinks(url)}
            >
              {icon}
            </IconButton>
          ))}
        </div>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(4, 1fr)",
            gap: isMobile ? "10px" : "0px",
            textAlign: "center",
            ...(isMobile
              ? {}
              : {
                  display: "flex",
                  justifyContent: "center",
                }),
          }}
        >
          <RouterLink
            to="/line"
            style={{
              marginLeft: isMobile ? "0" : "16px",
              textDecoration: "none",
              color: "inherit",
              fontSize: "12px",
            }}
          >
            お問い合わせ
          </RouterLink>
          <RouterLink
            to="/terms/"
            style={{
              marginLeft: isMobile ? "0" : "16px",
              textDecoration: "none",
              color: "inherit",
              fontSize: "12px",
            }}
          >
            利用規約
          </RouterLink>
          <RouterLink
            to="/law/"
            style={{
              marginLeft: isMobile ? "0" : "16px",
              textDecoration: "none",
              color: "inherit",
              fontSize: "12px",
            }}
          >
            特定商取引法に基づく表記
          </RouterLink>
          <RouterLink
            to="/privacyPolicy/"
            style={{
              marginLeft: isMobile ? "0" : "16px",
              textDecoration: "none",
              color: "inherit",
              fontSize: "12px",
            }}
          >
            プライバシーポリシー
          </RouterLink>
        </Box>
      </Typography>
    </Box>
  );
}
